<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="item">
      <div class="input-wrapper">
        <input type="text" v-model="deviceId" readonly />
      </div>
      <div class="input-wrapper">
        <input type="password" v-model="qrcode" maxlength="8" placeholder="请输入设备密码" />
      </div>
      <div class="row">
        <span @click="getNum('1')">1</span>
        <span @click="getNum('2')">2</span>
        <span @click="getNum('3')">3</span>
      </div>
      <div class="row">
        <span @click="getNum('4')">4</span>
        <span @click="getNum('5')">5</span>
        <span @click="getNum('6')">6</span>
      </div>
      <div class="row">
        <span @click="getNum('7')">7</span>
        <span @click="getNum('8')">8</span>
        <span @click="getNum('9')">9</span>
      </div>
      <div class="row">
        <span @click="delelteNum">
          <i class="iconfont iconshanchu"></i>
        </span>
        <span @click="getNum('0')">0</span>
        <span
          @click="getSend"
          :disabled="qrcode.length>=8?false:true"
          :class="{'active':qrcode.length>=8}"
        >
          <i class="iconfont iconquerenduigougouhao"></i>
        </span>
      </div>
    </div>

    <div class="footer">
      <p>
       <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850    25650860</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum||"123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      week: "",
      times: 60,
      qrcode: ""
    };
  },
  created() {
    var that = this;
  },
  mounted() {
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    //删除
    delelteNum() {
      this.qrcode = this.qrcode.substring(0, this.qrcode.length - 1);
    },
    getNum(num) {
      if (this.qrcode.length >= 16) {
        return false;
      }
      this.qrcode += num;
    },
    goBack() {
      this.$router.replace("/buy");
    },
    //设置密码
    getSend() {
      if ((this.qrcode = "88888888")) {
        this.$router.push("/page");
      }
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      var weeks = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          weeks = "周日";
          break;
        case 1:
          strWeek = "星期一";
          weeks = "周一";
          break;
        case 2:
          strWeek = "星期二";
          weeks = "周二";
          break;
        case 3:
          strWeek = "星期三";
          weeks = "周三";
          break;
        case 4:
          strWeek = "星期四";
          weeks = "周四";
          break;
        case 5:
          strWeek = "星期五";
          weeks = "周五";
          break;
        case 6:
          strWeek = "星期六";
          weeks = "周六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
      this.week = weeks;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  .top {
    padding: 68px 50px;
    color: #4d4d4d;
    font-size: 25px;
    height: 486px;
    position: relative;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .title {
      position: absolute;
      top: 100px;
      left: 55%;
      transform: translateX(-50%);
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 3px;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
}
.item {
  width: 650px;
  margin: 0 auto;
  border-radius: 6px;
  background-size: cover;
  &:first-child {
    margin-right: 60px;
    width: 390px;
    background-size: cover;
  }
  h3 {
    text-align: center;
    margin: 80px 0 60px;
    color: #005192;
    font-size: 40px;
    letter-spacing: 4px;
  }
  p {
    margin-top: 10px;
    text-align: center;
    color: #010101;
    font-size: 26px;
    line-height: 36px;
    width: 184px;
    margin: 0 auto;
    &.des {
      color: #8e8e8e;
      font-size: 30px;
    }
  }
  .img-qu {
    display: block;
    margin: 65px auto;
  }
  .input-wrapper {
    width: 540px;
    margin: 60px auto;
    height: 100px;
    border-radius: 50px;
    background: #cccccc;
    padding: 20px 30px;
    input {
      border: 0 none;
      outline: 0 none;
      display: block;
      width: 420px;
      margin: 10px auto;
      background: #cccccc;
      height: 40px;
      line-height: 40px;
      font-size: 38px;
      color: #434343;
      letter-spacing: 2px;
      text-align: center;
    }
  }
  .row {
    margin: 30px auto;
    width: 540px;
    span {
      width: 114px;
      height: 114px;
      display: inline-block;
      background: #ccc;
      border-radius: 50%;
      line-height: 114px;
      text-align: center;
      color: #434343;
      font-size: 48px;
      &:nth-child(2) {
        margin-left: 89.5px;
        margin-right: 89.5px;
      }
      &.active {
        background: #b95020;
        i {
          color: #fff;
        }
      }
      i {
        font-size: 48px;
        &.iconshanchu {
          display: inline-block;
          font-size: 30px;
          margin-top: -12px;
          vertical-align: middle;
        }
      }
    }
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 35%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: fixed;
  bottom: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Set.vue